var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70117 11H5.52851V13H3.70117V11ZM11.0105 5H12.8379V9H11.0105V5ZM9.18319 11H12.8379V15H11.0105V13H9.18319V11ZM14.6652 11H16.4925V13H18.3199V11H20.1472V13H18.3199V15H20.1472V19H18.3199V21H16.4925V19H12.8379V21H11.0105V17H14.6652V15H16.4925V13H14.6652V11ZM18.3199 19V15H16.4925V19H18.3199ZM14.6652 3H20.1472V9H14.6652V3ZM16.4925 5V7H18.3199V5H16.4925ZM3.70117 3H9.18319V9H3.70117V3ZM5.52851 5V7H7.35585V5H5.52851ZM3.70117 15H9.18319V21H3.70117V15ZM5.52851 17V19H7.35585V17H5.52851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.82e886a76d1c94418ddd23b2efdfedc2.svg";
export { ForwardRef as ReactComponent };